'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



// WEBPACK FOOTER //
// ./src/utilities/strict-uri-encode.js